////////////////////////////////////////////////Youtube
if (!customElements.get("dl-js-youtube")) {
  (function () {
    // ---- Safe loader: load Iframe API only once
    function loadYouTubeAPI() {
      return new Promise(function (resolve) {
        if (window.YT && window.YT.Player) return resolve();
        const prev = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
        if (!prev) {
          const tag = document.createElement("script");
          tag.src = "https://www.youtube.com/iframe_api";
          document.head.appendChild(tag);
        }
        const prevCb = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = function () {
          if (typeof prevCb === "function")
            try {
              prevCb();
            } catch (e) {}
          resolve();
        };
      });
    }

    class DL_Youtube extends HTMLElement {
      constructor() {
        super();
        this._onScroll = this.onScroll.bind(this);
        this._onResize = this.onResize.bind(this);
        this._ready = false;
        this._autoLoad = false;
        this._autoLoadTimer = null;
      }

      connectedCallback() {
        // Attach listeners here
        window.addEventListener("scroll", this._onScroll, { passive: true });
        window.addEventListener("resize", this._onResize);

        // Defer init until API ready (and element connected)
        loadYouTubeAPI().then(() => this.init());
      }

      disconnectedCallback() {
        // Clean up
        window.removeEventListener("scroll", this._onScroll);
        window.removeEventListener("resize", this._onResize);
        if (this._autoLoadTimer) {
          clearTimeout(this._autoLoadTimer);
          this._autoLoadTimer = null;
        }
        if (this.player && this.player.destroy) {
          try {
            this.player.destroy();
          } catch (e) {}
        }
      }

      // --- Utils (fallbacks) ---
      _media() {
        try {
          return typeof DL_media === "function" ? DL_media() : window.innerWidth <= 680 ? "SP" : "PC";
        } catch (e) {
          return window.innerWidth <= 680 ? "SP" : "PC";
        }
      }
      _offsetTop(el) {
        try {
          return typeof DL_offsetTop === "function" ? DL_offsetTop(el) : el.getBoundingClientRect().top + window.pageYOffset;
        } catch (e) {
          return el.getBoundingClientRect().top + window.pageYOffset;
        }
      }
      _addClass(el, c) {
        try {
          typeof DL_addClass === "function" ? DL_addClass(el, c) : el.classList.add(c);
        } catch (e) {
          el.classList.add(c);
        }
      }
      _removeClass(el, c) {
        try {
          typeof DL_removeClass === "function" ? DL_removeClass(el, c) : el.classList.remove(c);
        } catch (e) {
          el.classList.remove(c);
        }
      }

      init() {
        // Read attributes
        const el = this;
        const playerElement = el.querySelector(".dl-js-youtube__player");
        if (!playerElement) return;

        const idBase = el.getAttribute("data-id");
        const idSp = el.getAttribute("data-id_sp");
        el.idVideo = idSp && this._media() === "SP" ? idSp : idBase;

        el.playerId = el.getAttribute("data-player-id") || "YT-" + idBase;

        const parseBool = (v, def = false) => (v == null ? def : Boolean(JSON.parse(String(v))));
        el.auto = parseBool(el.getAttribute("data-auto"), true);
        el.controls = parseBool(el.getAttribute("data-controls"), false);
        el.mute = parseBool(el.getAttribute("data-mute"), true);
        el.loop = parseBool(el.getAttribute("data-loop"), true);

        el.ratio = parseFloat(el.getAttribute("data-ratio")) || 0.5625;
        el.ratio_sp = parseFloat(el.getAttribute("data-ratio_sp")) || el.ratio;

        el.width = el.offsetWidth;
        el.height = el.width * (this._media() === "SP" ? el.ratio_sp : el.ratio);
        el.top = this._offsetTop(el);

        // Build player (use official events)
        const playerVars = {
          autoplay: el.auto ? 1 : 0,
          controls: el.controls ? 1 : 0,
          loop: el.loop ? 1 : 0,
          playlist: el.loop ? el.idVideo : undefined, // REQUIRED for single-video loop
          rel: 0,
          modestbranding: 1,
          iv_load_policy: 3,
          playsinline: 1,
          wmode: "transparent",
        };

        this.player = new YT.Player(playerElement, {
          width: el.width,
          height: el.height,
          videoId: el.idVideo,
          playerVars,
          events: {
            onReady: (e) => this.onReady(e),
            onStateChange: (e) => this.onChange(e),
          },
        });

        this.onScroll();
      }

      onReady() {
        this._ready = true;
        // Apply mute state properly
        if (this.mute && this.player && this.player.mute) {
          this.player.mute();
        } else if (this.player && this.player.unMute) {
          this.player.unMute();
        }
        if (this.auto) {
          this.play();
          this.onScroll(); // enforce viewport logic
        }
      }

      onChange(event) {
        const s = event.data;
        if (!this.auto) {
          if (s === YT.PlayerState.PAUSED || s === YT.PlayerState.ENDED) this.pause();
          if (s === YT.PlayerState.BUFFERING) this.play();
        } else {
          if (s === YT.PlayerState.ENDED) {
            if (this.loop) {
              this.play(); // continuous loop
            }
            this.onScroll();
          }
        }
      }

      play() {
        if (this._ready && this.player && this.player.playVideo) {
          this.player.playVideo();
          this._addClass(this, "is-play");
        }
      }
      pause() {
        if (this._ready && this.player && this.player.pauseVideo) {
          this.player.pauseVideo();
          this._removeClass(this, "is-play");
        }
      }

      onScroll() {
        if (!this._ready) return;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const inView = scrollTop + window.innerHeight >= this.top && scrollTop <= this.top + this.height + window.innerHeight;

        if (this.auto) {
          if (inView) {
            if (this.player && this.player.getPlayerState && this.player.getPlayerState() !== YT.PlayerState.PLAYING) {
              if (!this._autoLoad) {
                this._autoLoad = true;
                if (this.player.seekTo) this.player.seekTo(0, true);
                if (this._autoLoadTimer) clearTimeout(this._autoLoadTimer);
                this._autoLoadTimer = null;
              }
              this.play();
            }
          } else {
            if (this.player && this.player.getPlayerState && this.player.getPlayerState() === YT.PlayerState.PLAYING) {
              // 初回ロゴ除去のためのワンショット再生 → 頭出し停止
              if (!this._autoLoad) {
                if (!this._autoLoadTimer) {
                  this.play();
                  this._autoLoadTimer = setTimeout(() => {
                    this._autoLoad = true;
                    if (this.player.seekTo) this.player.seekTo(0, true);
                    this.pause();
                    clearTimeout(this._autoLoadTimer);
                    this._autoLoadTimer = null;
                  }, 3000);
                }
              } else {
                this.pause();
              }
            }
          }
        } else {
          // 手動再生モード：ビューポート外であれば止める
          if (this.player && this.player.getPlayerState && this.player.getPlayerState() === YT.PlayerState.PLAYING && !inView) {
            this.pause();
          }
        }
      }

      onResize() {
        // swap id for SP/PC if needed
        const idBase = this.getAttribute("data-id");
        const idSp = this.getAttribute("data-id_sp");
        const prevId = this.idVideo;

        this.idVideo = idSp && this._media() === "SP" ? idSp : idBase;
        if (this.player && prevId && this.idVideo && prevId !== this.idVideo) {
          this.player.cueVideoById(this.idVideo);
        }

        // recompute size
        const r = parseFloat(this.getAttribute("data-ratio")) || 0.5625;
        const rs = parseFloat(this.getAttribute("data-ratio_sp")) || r;
        this.width = this.offsetWidth;
        this.height = this.width * (this._media() === "SP" ? rs : r);
        this.top = this._offsetTop(this);

        if (this.player && this.player.setSize) {
          this.player.setSize(this.width, this.height);
        }
      }
    }

    // Define only once, after API ready (but we also guard here)
    if (!customElements.get("dl-js-youtube")) {
      // Define immediately; player init waits for API internally
      customElements.define("dl-js-youtube", DL_Youtube);
    }
  })();
}
